<nz-spin [nzSize]="'small'"
         [nzSpinning]="loading">
  <div *ngIf="country" class="grid grid-cols-1 mb-3">
    <div>
      <label
        class="mb-1"
        nz-checkbox
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="currentCountryBoxChecked"
        (ngModelChange)="onChangeCurrentCountry($event)"
      >{{ 'itineraries.experiences.form.displayExperiencesOnlyFrom' | transloco }} {{ this.country }}</label>
    </div>
  </div>
  <div class="grid grid-cols-1 overflow-visible">
    <div class="flex flex-row items-center gap-3 overflow-visible">
      <nz-select class="flex-1 min-w-0"
        nzShowSearch
        nzServerSearch
        [nzPlaceHolder]="'itineraries.experiences.form.searchExperiences' | transloco"
        [(ngModel)]="selectedExperiences"
        [nzShowArrow]="false"
        (nzOnSearch)="search($event)"
        (ngModelChange)="selectedExperience(selectedExperiences)"
      >
        <nz-option
          nzCustomContent
          *ngFor="let option of listOfOption"
          [nzLabel]="option.placePrediction.entry !== undefined ? option.placePrediction.text.text : option.placePrediction.text.text"
          [nzValue]="option.placePrediction">
          <div class="flex justify-start items-center">
            <div class="mr-2">
              <lucide-icon
                class="search-icons flex"
                [name]="option.placePrediction.entry !== undefined ? 'plus' : this.getIcon(option.placePrediction)">
              </lucide-icon>
            </div>
            <div [ngClass]="option.placePrediction.entry !== undefined ? 'text-primary font-medium' : ''">
              <span *ngIf="option.placePrediction.entry !== undefined" class="text-xs text-gray-400 mr-1">{{ 'itineraries.experiences.form.create' | transloco }}:</span>
              {{ option.placePrediction.text.text }}
            </div>
          </div>
        </nz-option>
      </nz-select>
    </div>
  </div>
  <nz-divider class="mb-3"></nz-divider>

  <!-- Add New Experience Modal -->
  <nz-modal
    [(nzVisible)]="isAddExperienceModalVisible"
    [nzTitle]="'itineraries.experiences.form.addNewExperience' | transloco"
    [nzFooter]="null"
    (nzOnCancel)="closeAddExperienceModal()">
    <ng-container *nzModalContent>
      <div class="grid xl:grid-cols-1 sm:grid-cols-1">
        <div>
          <nz-select
            class="w-full"
            nzShowSearch
            nzServerSearch
            [nzPlaceHolder]="'itineraries.experiences.form.searchExperience' | transloco"
            [(ngModel)]="addExpSearchName"
            [nzShowArrow]="false"
            (nzOnSearch)="searchNewExperience($event)"
            (ngModelChange)="selectedNewExperienceResult(addExpSearchName)">
            <nz-option
              nzCustomContent
              *ngFor="let option of addExpListOfOption"
              nzLabel="{{ option.placePrediction.entry ? option.placePrediction.text.text + ' [Manual]' : option.placePrediction.text.text }}"
              [nzValue]="option.placePrediction">
              <div class="flex justify-start items-center">
                <div class="mr-2" *ngIf="option.placePrediction.entry !== undefined">
                  <lucide-icon class="search-icons flex" name="plus"></lucide-icon>
                </div>
                <div [ngClass]="option.placePrediction.entry ? 'text-primary' : 'text-[#000000d9]'">
                  {{ option.placePrediction.text.text }}
                </div>
              </div>
            </nz-option>
          </nz-select>

          <div class="mt-5 flex justify-end">
            <button
              nz-button
              class="mr-2"
              nzType="primary"
              [nzLoading]="addExpLoading"
              [disabled]="!addExpIsDetailsExist"
              (click)="addNewExperience()">
              {{ 'itineraries.experiences.form.add' | transloco }}
            </button>
            <button nz-button nzType="default" (click)="resetNewExperience()">{{ 'itineraries.experiences.form.reset' | transloco }}</button>
          </div>
        </div>
      </div>

      <div class="mt-5 grid grid-cols-12">
        <div class="col-span-12">
          <nz-alert
            *ngIf="addExpActionMessage.display && addExpActionMessage.isAdd"
            [nzType]="addExpActionMessage.type"
            [nzMessage]="addExpActionMessage.message"
            nzShowIcon
            nzCloseable>
          </nz-alert>
        </div>
      </div>
    </ng-container>
  </nz-modal>

  <form nzLayout="vertical" nz-form [formGroup]="experiencesForm">
    <nz-form-item class="mb-1.5">
      <nz-form-control>
        <label
          class="mb-1"
          nz-checkbox
          formControlName="isCustomTitle"
        >{{ 'itineraries.experiences.form.editDisplayTitle' | transloco }}</label>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item *ngIf="this.experiencesForm.get('isCustomTitle')?.value">
      <nz-form-label  nzFor="title">{{ 'itineraries.experiences.form.title' | transloco }}</nz-form-label>
      <nz-form-control [nzErrorTip]="titleCheck">
          <input
            nz-input
            [attr.placeholder]="'itineraries.experiences.form.enterYourTitle' | transloco"
            formControlName="customTitle"/>
      </nz-form-control>
      <ng-template #titleCheck>
          <span *ngIf="formErrors.customTitle.required">
              {{ 'itineraries.experiences.form.errors.titleRequired' | transloco }}
          </span>
      </ng-template>
    </nz-form-item>
  </form>

  <h5 class="mb-3">{{ this.title }}</h5>
  <div>
    <nz-alert nzType="info" nzShowIcon
              [nzMessage]="'itineraries.experiences.form.uploadHdImageInfo' | transloco"></nz-alert>
  </div>
  <div class="mt-5 grid grid-cols-12 gap-5">
    <div class="col-span-4">
      <form nz-form [formGroup]="featuredForm">
        <div>
          <div class="grid grid-cols-1">
            <div class="relative w-full aspect-[16/9]" *ngIf="this.getSelectedImage() !== '' && this.getSelectedImage() !==undefined">
              <!-- Image positioner: drag to reposition -->
              <app-image-positioner
                [imageSrc]="getSelectedImage()"
                [state]="currentImagePosition"
                [aspectRatio]="'16 / 9'"
                (stateChange)="onImagePositionChange($event)">
              </app-image-positioner>
              <button
                nz-button
                nzType="default"
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white/80 backdrop-blur-sm p-2 rounded-full shadow"
                style="z-index: 10;"
                (click)="removeSelectedImage()"
              >
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>
          </div>
          <div class="grid grid-cols-1">
            <nz-radio-group
              class="my-3 grid grid-cols-4 md:grid-cols-3 justify-items-center"
              nzButtonStyle="solid"
              [ngModel]="featuredForm.get('image')?.value"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="featuredForm.patchValue({ image: $event })">
              <label
                class="w-16 h-16 md:w-12 md:h-12 p-1 mb-2"
                *ngFor="let img of getUploadImages()"
                nz-radio-button
                [nzValue]="img">
                <img
                  class="w-full h-full object-cover"
                  [src]="img"
                  alt=""/>
                  <span nz-popconfirm
                      [nzPopconfirmTitle]="'itineraries.experiences.form.deleteImageConfirm' | transloco"
                      nzPopconfirmPlacement="top"
                      [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                      [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                      (nzOnConfirm)="deleteImage(img)"
                      (nzOnCancel)="cancel()"
                        class="text-[#F96074] cursor-pointer flex justify-center mt-2">
                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                  </span>
              </label>
            </nz-radio-group>
            <div class="mb-2">
              <p
                class="text-danger text-sm"
                *ngIf="formErrors.image.required">
                {{ 'itineraries.experiences.form.errors.imageRequired' | transloco }}
              </p>
              <p
                class="text-danger text-sm"
                *ngIf="this.featuredForm.controls.image.status === 'INVALID'">
                {{ 'itineraries.experiences.form.errors.imageTileRequired' | transloco }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="!this.isImageExist">
          <nz-upload
            class="custom-upload-size-modal-content"
            [(nzFileList)]="fileList"
            [nzShowButton]="fileList.length < 8"
            [nzPreview]="handlePreview"
            [nzCustomRequest]="customUploadReq"
            (nzChange)="handleChange($event)"
            nzListType="picture-card"
            nzAccept="image/png,image/jpg,image/jpeg"
            [nzHeaders]="setMediaUploadHeaders"
            [nzRemove]="onRemove"
            [nzShowUploadList]="false">
            <div>
              <span nz-icon nzType="upload" nzTheme="outline"></span>
            </div>
          </nz-upload>
        </div>
        <div *ngIf="this.isImageExist">
          <nz-upload
            [(nzFileList)]="fileList"
            [nzShowButton]="fileList.length < 8"
            [nzCustomRequest]="customUploadReq"
            (nzChange)="handleChange($event)"
            nzAccept="image/png,image/jpg,image/jpeg"
            [nzHeaders]="setMediaUploadHeaders"
            [nzRemove]="onRemove"
            [nzShowUploadList]="false">
            <div class="mt-3">
              <p>
                <span class="me-2" nz-icon nzType="upload"></span>
                <a>{{ 'itineraries.experiences.form.clickToUploadMore' | transloco }}</a>
              </p>
            </div>
          </nz-upload>
        </div>
      </form>
      <form nz-form [formGroup]="featuredForm">
        <div *ngIf="this.experienceDTO.images.length !== 0 && type !== 'new'">
          <h5 class="mt-3">{{ 'itineraries.experiences.form.sharedContent' | transloco }}</h5>
          <div class="grid grid-cols-1">
            <nz-radio-group
              class="my-3 grid grid-cols-4 md:grid-cols-3 justify-items-center "
              nzButtonStyle="solid"
              [ngModel]="featuredForm.get('image')?.value"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="featuredForm.patchValue({ image: $event })">
              <label
                class="w-16 h-16 md:w-12 md:h-12 p-1 mb-2"
                *ngFor="let img of images"
                nz-radio-button
                [nzValue]="img">
                <img
                  class="w-full h-full object-cover"
                  [src]="img"
                  alt=""/>
              </label>
            </nz-radio-group>
            <div class="mb-2">
              <p
                class="text-danger text-sm"
                *ngIf="formErrors.image.required">
                {{ 'itineraries.experiences.form.errors.imageRequired' | transloco }}
              </p>
              <p
                class="text-danger text-sm"
                *ngIf="this.featuredForm.controls.image.status === 'INVALID'">
                {{ 'itineraries.experiences.form.errors.imageTileRequired' | transloco }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-span-8">
      <form nz-form [formGroup]="featuredForm">
        <nz-form-item>
          <nz-form-control [nzErrorTip]="descriptionCheck">
                        <quill-editor
                          class="w-full h-52"
                          formControlName="body">
                          <div quill-editor-toolbar>
                            <div class="ql-formats">
                              <button class="ql-bold"></button>
                              <button class="ql-italic"></button>
                            </div>
                          </div>
                        </quill-editor>
          </nz-form-control>
          <ng-template #descriptionCheck>
              <span *ngIf="formErrors.body?.required">
                {{ 'itineraries.experiences.form.errors.descriptionRequired' | transloco }}
              </span>
          </ng-template>
        </nz-form-item>
        <div *ngIf="isDisplayAiButton" class="flex justify-end my-3">
          <button class="ai-button flex items-center" nz-button nzType="default"
                  (click)="getGeneratedContent({name: this.title, language: this.itinerary.tour.language})">
            <span nz-icon nzType="plus"></span>
            {{ 'itineraries.experiences.form.quickGenerate' | transloco }}
          </button>
        </div>
        <div>
          <nz-radio-group
            class="my-3 flex flex-wrap custom-radio-radius"
            nzButtonStyle="solid"
            formControlName="keyword">
            <label class="mr-3 mb-3"
                   [(ngModel)]="radioValue"
                   *ngFor="let text of this.contexts; let i =index"
                   [ngStyle]="text.keyword === 'Custom' ? { 'background-color': '#F5F5F5','color': '#222'} : {}"
                   nz-radio-button
                   (click)="selectedKeyword(text.body)"
                   [nzValue]="text.keyword">
              {{ text.keyword }}
            </label>
          </nz-radio-group>
          <div>
            <p
              class="text-danger text-sm"
              *ngIf="formErrors.keyword?.required">
              {{ 'itineraries.experiences.form.errors.keywordRequired' | transloco }}
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div class="grid grid-cols-12 gap-5">
    <div class="col-span-12">
      <form nzLayout="vertical" nz-form [formGroup]="experiencesForm">
        <nz-form-item class="flex">
          <nz-form-label nzFor="customUrl"
          >{{ 'itineraries.experiences.form.url' | transloco }}
          </nz-form-label
          >
          <nz-form-control>
            <input formControlName="customUrl"
                   type="text"
                   class="w-full"
                   [placeholder]="'itineraries.experiences.form.enterUrl' | transloco"
                   nz-input>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
    <div class="col-span-6">
      <nz-select nzMode="tags" [nzPlaceHolder]="'itineraries.experiences.form.selectDays' | transloco" [nzShowArrow]="true" nzAllowClear
                 [(ngModel)]="listOfTagOptions">
        <nz-option *ngFor="let option of this.itinerary.experiences; let i = index"
                   [nzLabel]="!itinerary.tour.isDatesOptional ?
          'Day ' + (i + 1) + ' - ' + (option.date | date: 'dd/MM/yyyy'): 'Day ' + (i + 1)" [nzValue]="i">
        </nz-option>
      </nz-select>
      <div class="mt-1" *ngIf="listOfTagOptions.length ===0">
        <p class=" ps-1 text-[#ff4d4f]" style="font-size: 0.85rem">
          {{ 'itineraries.experiences.form.errors.dateRequired' | transloco }}
        </p>
      </div>
    </div>
    <div class="col-span-6">
      <nz-select [formControl]="experiencesForm.get('time')" nzAllowClear [nzPlaceHolder]="'itineraries.experiences.form.selectTime' | transloco">
        <nz-option *ngFor="let option of timeOptions" [nzLabel]="option.label | transloco" [nzValue]="option.value"></nz-option>
      </nz-select>
    </div>
    <div class="col-span-12 mt-4">
      <nz-card class="mb-4 hover:cursor-pointer select-none"
               (click)="this.toggleCosting = !this.toggleCosting">
        <div class="flex flex-row items-center justify-between">
          <div>
            <h6 class="font-normal text-lg">{{ 'itineraries.experiences.form.costing' | transloco }}</h6>
          </div>
          <div class="flex flex-row items-center gap-2">
            <span
              *ngIf="experiencesForm.get('costType').value !== 'free' && getTotalCost() !== 0"
              class="font-normal text-lg">
              {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
              {{ getTotalCost() | number:'1.2-2' }}
            </span>
            <span
              *ngIf="experiencesForm.get('costType').value === 'free'"
              class="font-normal text-lg">
              {{ 'itineraries.experiences.form.free' | transloco }}
            </span>
            <span nz-icon [nzType]="this.toggleCosting ? 'up' : 'down'" nzTheme="outline"></span>
          </div>
        </div>

        <div *ngIf="this.toggleCosting" (click)="$event.stopPropagation()">
          <nz-divider></nz-divider>

          <div class="flex flex-row">

              <nz-tag [nzColor]="'purple'"
              >{{ this.itinerary?.tour.pax.adults }} {{ 'itineraries.experiences.form.adults' | transloco }}
              </nz-tag
              >
              <nz-tag [nzColor]="'purple'"
              >{{ this.itinerary?.tour.pax.children }} {{ 'itineraries.experiences.form.children' | transloco }}
              </nz-tag
              >
              <nz-tag [nzColor]="'purple'"
              >{{ this.itinerary?.tour.pax.infants }} {{ 'itineraries.experiences.form.infants' | transloco }}
              </nz-tag
              >
          </div>

          <div class="flex flex-row justify-between items-center  mt-8 mb-7">
            <nz-form-item class="mb-0 flex flex-row items-center gap-2" style="flex-direction: row">
              <nz-form-label nzFor="costType">{{ 'itineraries.experiences.form.type' | transloco }}</nz-form-label>
              <div class="cost-type-select">
                <nz-select
                  [ngModel]="experiencesForm.get('costType').value"
                  (ngModelChange)="experiencesForm.get('costType').setValue($event)"
                  [ngModelOptions]="{standalone: true}"
                  [nzPlaceHolder]="'itineraries.experiences.form.selectType' | transloco">
                  <nz-option
                    *ngFor="let opt of costTypeOptions"
                    [nzValue]="opt.value"
                    [nzLabel]="opt.label"></nz-option>
                </nz-select>
              </div>
            </nz-form-item>
            <nz-form-item *ngIf="experiencesForm.get('costType').value !== 'free'" class="mb-0 flex flex-row items-center gap-2" style="flex-direction: row">
              <nz-form-label nzFor="costingCurrency">{{ 'itineraries.experiences.form.costingCurrency' | transloco }}</nz-form-label>
              <div class="w-24">
                <nz-select [(ngModel)]="this.isPrimaryCurrency" [ngModelOptions]="{standalone: true}">
                  <nz-option
                    *ngFor="let lang of this.currencies"
                    [nzValue]="lang?.value"
                    [nzLabel]="lang?.label"></nz-option>
                </nz-select>
              </div>
            </nz-form-item>
          </div>

          <!-- Per Person fields -->
          <form *ngIf="experiencesForm.get('costType').value === 'perPerson'"
                class="flex flex-row gap-5" nzLayout="vertical" nz-form [formGroup]="experiencesForm">
            <nz-form-item>
              <nz-form-label nzFor="costPerAdult">{{ 'itineraries.experiences.form.costPerAdult' | transloco }}</nz-form-label>
              <nz-form-control [nzErrorTip]="costPerAdultCheck">
                <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 prefix-custom">
                  <nz-input-number
                    [nzFormatter]="formatter"
                    [nzParser]="parser"
                    [nzPrecision]="2"
                    [nzStep]="0.01"
                    class="w-full border-none"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraries.experiences.form.amount' | transloco"
                    formControlName="costPerAdult"></nz-input-number>
                </nz-input-group>
                <ng-template #prefixCurrency>{{
                    this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                  }}
                </ng-template>
              </nz-form-control>
              <ng-template #costPerAdultCheck>
                <span *ngIf="formErrors.costPerAdult.required">{{ 'itineraries.experiences.form.errors.costPerAdultRequired' | transloco }}</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label nzFor="costPerChild">{{ 'itineraries.experiences.form.costPerChild' | transloco }}</nz-form-label>
              <nz-form-control [nzErrorTip]="costPerChildCheck">
                <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 prefix-custom">
                  <nz-input-number
                    [nzFormatter]="formatter"
                    [nzParser]="parser"
                    [nzPrecision]="2"
                    [nzStep]="0.01"
                    class="w-full border-none"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraries.experiences.form.amount' | transloco"
                    formControlName="costPerChild"></nz-input-number>
                </nz-input-group>
                <ng-template #prefixCurrency>{{
                    this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                  }}
                </ng-template>
              </nz-form-control>
              <ng-template #costPerChildCheck>
                <span *ngIf="formErrors.costPerChild.required">{{ 'itineraries.experiences.form.errors.costPerChildRequired' | transloco }}</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label nzFor="costPerInfant">{{ 'itineraries.experiences.form.costPerInfant' | transloco }}</nz-form-label>
              <nz-form-control [nzErrorTip]="costPerInfantCheck">
                <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 prefix-custom">
                  <nz-input-number
                    [nzFormatter]="formatter"
                    [nzParser]="parser"
                    [nzPrecision]="2"
                    [nzStep]="0.01"
                    class="w-full border-none"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraries.experiences.form.amount' | transloco"
                    formControlName="costPerInfant"></nz-input-number>
                </nz-input-group>
                <ng-template #prefixCurrency>{{
                    this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                  }}
                </ng-template>
              </nz-form-control>
              <ng-template #costPerInfantCheck>
                <span *ngIf="formErrors.costPerInfant.required">{{ 'itineraries.experiences.form.errors.costPerInfantRequired' | transloco }}</span>
              </ng-template>
            </nz-form-item>
          </form>

          <!-- Per Group fields -->
          <div *ngIf="experiencesForm.get('costType').value === 'perGroup'">
            <form class="flex flex-row flex-wrap gap-5 items-end" nzLayout="vertical" nz-form [formGroup]="experiencesForm">

              <!-- Cost -->
              <nz-form-item formGroupName="costing">
                <nz-form-label nzFor="cost">{{ 'itineraries.experiences.form.cost' | transloco }}</nz-form-label>
                <nz-form-control>
                  <nz-input-group nzSearch [nzPrefix]="prefixGroupCurrency" class="py-0 prefix-custom">
                    <nz-input-number
                      [nzFormatter]="formatter"
                      [nzParser]="parser"
                      [nzPrecision]="2"
                      [nzStep]="0.01"
                      class="w-full border-none"
                      [nzMin]="0"
                      [nzPlaceHolder]="'itineraries.experiences.form.amount' | transloco"
                      formControlName="cost"></nz-input-number>
                  </nz-input-group>
                  <ng-template #prefixGroupCurrency>{{
                      this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                    }}
                  </ng-template>
                </nz-form-control>
              </nz-form-item>

              <!-- maximum Pax -->
              <nz-form-item formGroupName="costing">
                <nz-form-label nzFor="maximumPax">{{ 'itineraries.experiences.form.maximumPax' | transloco }}</nz-form-label>
                <nz-form-control>
                  <nz-input-number
                    class="w-32"
                    [nzMin]="0"
                    [nzStep]="1"
                    formControlName="maximumPax">
                  </nz-input-number>
                </nz-form-control>
              </nz-form-item>

              <!-- Quantity -->
              <nz-form-item formGroupName="costing">
                <nz-form-label nzFor="quantity">{{ 'itineraries.experiences.form.quantity' | transloco }}</nz-form-label>
                <nz-form-control>
                  <nz-input-number
                    class="w-32"
                    [nzMin]="0"
                    [nzStep]="1"
                    formControlName="quantity">
                  </nz-input-number>
                </nz-form-control>
              </nz-form-item>

            </form>

            <!-- Advanced Options -->
            <div class="mt-4">
              <div class="flex flex-row items-center gap-2 mb-3" [formGroup]="experiencesForm">
                <label nz-checkbox formGroupName="advancedOptions" [formControl]="$any(experiencesForm.get('advancedOptions.isChecked'))"></label>
                <span class="font-medium">{{ 'itineraries.experiences.form.advancedOptions' | transloco }}</span>
              </div>

              <div *ngIf="experiencesForm.get('advancedOptions.isChecked')?.value">
                <form class="flex flex-row flex-wrap gap-5 items-end" nzLayout="vertical" nz-form [formGroup]="experiencesForm">

                  <!-- Included Pax -->
                  <nz-form-item formGroupName="advancedOptions">
                    <nz-form-label nzFor="includedPax">{{ 'itineraries.experiences.form.includedPax' | transloco }}</nz-form-label>
                    <nz-form-control>
                      <input
                        nz-input
                        type="number"
                        class="w-36"
                        [placeholder]="'itineraries.experiences.form.zero' | transloco"
                        formControlName="includedPax" />
                    </nz-form-control>
                  </nz-form-item>

                  <!-- Extra Pax Cost -->
                  <nz-form-item formGroupName="advancedOptions">
                    <nz-form-label nzFor="extraPaxCost">{{ 'itineraries.experiences.form.extraPaxCost' | transloco }}</nz-form-label>
                    <nz-form-control>
                      <nz-input-group nzSearch [nzPrefix]="prefixExtraCurrency" class="py-0 prefix-custom">
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          [nzStep]="0.01"
                          class="w-full border-none"
                          [nzMin]="0"
                          [nzPlaceHolder]="'itineraries.experiences.form.amount' | transloco"
                          formControlName="extraPaxCost"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixExtraCurrency>{{
                          this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>

                </form>
              </div>
            </div>
          </div>

          <nz-divider *ngIf="experiencesForm.get('costType').value !== 'free'"></nz-divider>

          <!-- Subtotal -->
          <div *ngIf="experiencesForm.get('costType').value !== 'free'" class="flex justify-between items-center mb-4 bg-base-200 p-4">
            <span class="font-semibold">{{ 'itineraries.experiences.form.subtotal' | transloco }}</span>
            <span class="font-semibold">
              {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
              {{ getSubTotal() | number:'1.2-2' }}
            </span>
          </div>

          <!-- Markup -->
          <div *ngIf="experiencesForm.get('costType').value !== 'free'" class="mb-4">
            <form nzLayout="vertical" nz-form [formGroup]="$any(experiencesForm.get('costing'))">
              <nz-form-item class="flex items-center mb-0" style="flex-direction: row">
                <nz-form-label class="w-52" nzFor="markupRatio">{{ 'itineraries.experiences.form.markup' | transloco }}</nz-form-label>
                <nz-form-control>
                  <ng-template #prefixPercentMarkup></ng-template>
                  <ng-template #prefixFixedMarkup>
                    {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
                  </ng-template>
                  <nz-input-group
                    [nzPrefix]="experiencesForm.get('costing.markupSymbol').value === 'FIXED' ? prefixFixedMarkup : prefixPercentMarkup"
                    class="pr-0 py-0 prefix-custom">
                    <nz-input-number
                      [nzFormatter]="formatter"
                      [nzParser]="parser"
                      [nzPrecision]="2"
                      [nzStep]="0.01"
                      [style.width]="experiencesForm.get('costing.markupSymbol').value === 'FIXED' ? '60%' : '70%'"
                      class="border-none"
                      [nzMin]="0"
                      [nzPlaceHolder]="experiencesForm.get('costing.markupSymbol').value === 'FIXED' ? translocoService.translate('itineraries.experiences.form.amount') : translocoService.translate('itineraries.experiences.form.percentage')"
                      formControlName="markupRatio">
                    </nz-input-number>
                    <nz-select formControlName="markupSymbol" style="width: 30%">
                      <nz-option *ngFor="let op of fixedPercentSymbol" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
                    </nz-select>
                  </nz-input-group>
                </nz-form-control>
              </nz-form-item>
            </form>
          </div>

          <!-- Total Cost -->
          <div class="flex justify-between items-center bg-base-200 p-4">
            <span class="font-bold">{{ 'itineraries.experiences.form.totalCost' | transloco }}</span>
            <span class="font-bold">
              <ng-container *ngIf="experiencesForm.get('costType').value !== 'free'">
                {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
                {{ getTotalCost() | number:'1.2-2' }}
              </ng-container>
              <ng-container *ngIf="experiencesForm.get('costType').value === 'free'">
                0.00
              </ng-container>
            </span>
          </div>

        </div>
      </nz-card>
    </div>
    <div class="col-span-12 mt-4">
      <form nzLayout="vertical" nz-form [formGroup]="experiencesForm">
        <nz-form-item>
          <nz-radio-group formControlName="conditionType">
            <label *ngFor="let cond of conditionTypes"
                   nz-radio-button
                   [nzValue]="cond.value"
                   [ngClass]="getConditionClass(cond.value)">
                {{cond.label}}
            </label>
          </nz-radio-group>
        </nz-form-item>
      </form>
    </div>
    <div class="col-span-12 mt-4">
      <nz-card class="mb-4 hover:cursor-pointer select-none"
               (click)="this.toggleNotes = !this.toggleNotes">
        <div class="flex flex-row items-center justify-between">
          <div>
            <span class="font-normal text-lg">{{ 'itineraries.experiences.form.additionalNotes' | transloco }}</span>
          </div>
          <div>
            <span nz-icon [nzType]="this.toggleNotes ? 'up' : 'down'" nzTheme="outline"></span>
          </div>
        </div>
        <div *ngIf="this.toggleNotes" (click)="$event.stopPropagation()">
          <nz-divider></nz-divider>
          <nz-form-item>
            <nz-form-control>
              <textarea
                class="select-text"
                [placeholder]="'itineraries.experiences.form.addNotesOptional' | transloco"
                nz-input
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="this.notes"
                rows="6"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.experiences.form.close' | transloco }}</button>
    <button nz-button nzType="primary" (click)="addExperiences()"
            [nzLoading]="this.isButtonLoading"
            [disabled]="!this.featuredForm.valid || !this.experiencesForm.valid || this.listOfTagOptions.length ===0">
      {{ this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT ? ('itineraries.experiences.form.edit' | transloco) : ('itineraries.experiences.form.add' | transloco) }}
    </button>
  </div>
</nz-spin>
